import React, { useEffect, useState, useRef } from "react";
import Navbar from "../Navbar";
import "../../assets/css/bazaar.css";
import axios from "axios";
import { Config } from "../../Config";
import Loader from "../Loader";
import Footer from "../Footer";

const AffordablePolicy = () => {
  const [policyPage, setPolicyPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const fetched = useRef(false);

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, []);

  useEffect(() => {
    if (fetched.current) {
      setLoading(false);
      return;
    }

    fetched.current = true;

    axios
      .get(`${Config.apiUrl}/policy`, {
        headers: {
          //'Authorization': 'Bearer ',
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setPolicyPage(response.data.policy_page);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was a problem fetching the data:", error);
        setLoading(false);
        setError(true);
      });
  }, []);

  // Skeleton component
  const SkeletonBanner = () => (
    <section
      className="py-5"
      style={{
        background: "#f8f9fa",
        position: "relative",
        color: "#6c757d",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.1)",
          zIndex: 1,
        }}
      ></div>
      <div
        className="container-box py-md-5"
        style={{ position: "relative", zIndex: 2 }}
      >
        <div className="text-center">
          <div className="skeleton-title mb-3"></div>
          <div className="skeleton-subtitle"></div>
        </div>
      </div>
    </section>
  );

  const SkeletonTable = () => (
    <section className="py-5">
      <div className="container-box py-md-2">
        <div className="text-center">
          <div className="skeleton-h1 mb-3"></div>
          <div className="skeleton-hr mb-3"></div>
        </div>
        <div className="container px-5"> 
          <div className="table-responsive"> 
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>
                    <div className="skeleton-text small"></div>
                  </th>
                  <th>
                    <div className="skeleton-text small"></div>
                  </th>
                  <th>
                    <div className="skeleton-text small"></div>
                  </th>
                  <th>
                    <div className="skeleton-text small"></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="skeleton-text small"></div>
                  </td>
                  <td>
                    <div className="skeleton-text"></div>
                  </td>
                  <td>
                    <div className="skeleton-text small"></div>
                  </td>
                  <td>
                    <div className="skeleton-btn"></div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="skeleton-text small"></div>
                  </td>
                  <td>
                    <div className="skeleton-text"></div>
                  </td>
                  <td>
                    <div className="skeleton-text small"></div>
                  </td>
                  <td>
                    <div className="skeleton-btn"></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );

  // Skeleton styles (can be moved to CSS)
  const skeletonStyles = `
    .skeleton-title { width: 60%; height: 40px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; margin: 0 auto; border-radius: 4px; }
    .skeleton-subtitle { width: 80%; height: 20px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; margin: 0 auto; border-radius: 4px; }
    .skeleton-h1 { width: 40%; height: 50px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; margin: 0 auto; border-radius: 4px; }
    .skeleton-hr { width: 100px; height: 3px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; margin: 10px auto; border-radius: 2px; }
    .skeleton-text { height: 20px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px; margin: 0 auto; }
    .skeleton-text.small { width: 80%; height: 16px; }
    .skeleton-btn { width: 60px; height: 30px; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 4px; margin: 0 auto; }
    @keyframes loading { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
  `;

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = skeletonStyles;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  if (loading || error || !policyPage) {
    return (
      <>
        <Navbar />
        <div className="page-content pb-5">
          <SkeletonBanner />
          <SkeletonTable />
        </div>
      </>
    );
  }

  const affordable = policyPage.affordable;
  const affordablePolicies = policyPage.affordable_policies
    .filter((policy) => policy.approval_status === true)
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  let bgImagePath = "";
  if (affordable?.affordable_bg_image) {
    let rawPath = `${Config.apiUrl}${affordable.affordable_bg_image}`;
    rawPath = rawPath.replace(/\/api\/?/, "/");
    bgImagePath = encodeURI(rawPath);
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <>
      <Navbar />
      <div className="page-content pb-5">
        {/* Banner Section with BG Image */}
        <section
          className="py-5"
          style={{
            backgroundImage: `url(${bgImagePath})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
            color: "white",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1,
            }}
          ></div>
          <div
            className="container-box py-md-5"
            style={{ position: "relative", zIndex: 2 }}
          >
            <div className="text-center text-white">
              <h2 className="fw-bold text-capitalize mb-3">
                {affordable.affordable_title || "Affordable Policy"}
              </h2>
              <p className="text-center text-white ">
                {affordable.affordable_subtitle || ""}
              </p>
            </div>
          </div>
        </section>

        <section className="py-3 ">
          <div className="container-box py-md-2">
            <h1 className="text-center fw-bold mb-1" style={{ margin: 0 }}>
              Affordable Policies
            </h1>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "0px 0px", // remove extra spacing
              }}
            >
              <hr
                style={{
                  color: "red",
                  width: "100px",
                  borderTop: "3px solid red",
                  // margin: "10px 10px", // remove default hr margin
                }}
              />
            </div>

            <div className="container px-5">
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead className="table-success">
                    <tr>
                      <th className="text-center">Sr No</th>
                      <th>Name of Policy Document</th>
                      <th className="text-center">Date</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {affordablePolicies.length > 0 ? (
                      affordablePolicies.map((policy, index) => (
                        <tr key={policy.id}>
                          <td className="text-center">{index + 1}</td>
                          <td>{policy.title}</td>
                          <td className="text-center">
                            {formatDate(policy.date)}
                          </td>
                          <td className="text-center">
                            {policy.file && (
                              <a
                                href={`${Config.docUrl}${policy.file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-success"
                              >
                                Download
                              </a>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No approved policies available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AffordablePolicy;
